import { useState } from 'react';
import { api } from '../api.js';
import { Button, Field } from '../ui.jsx';

export default function Login({ go }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e?.preventDefault();
    if (busy) return;
    if (!email.trim() || !password) return setErr('يرجى إدخال البريد وكلمة المرور');
    setBusy(true);
    setErr('');
    try {
      await api('/api/auth/login', { method: 'POST', body: { email, password } });
      go('/admin');
    } catch (e2) {
      setErr(e2.message || 'فشل تسجيل الدخول');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-page">
      <form className="auth-card" onSubmit={submit}>
        <div className="auth-logo">🔐</div>
        <h1>تسجيل الدخول</h1>
        <p className="muted">أدخل بيانات حساب المشرف للمتابعة</p>

        <Field label="البريد الإلكتروني" required>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="boss71132"
            autoFocus
          />
        </Field>

        <Field label="كلمة المرور" required>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
          />
        </Field>

        {err && <p className="error">{err}</p>}

        <Button type="submit" variant="primary" className="full" disabled={busy}>
          {busy ? 'جارِ الدخول...' : 'دخول'}
        </Button>

        <a className="muted small center-text" href="/report">
          صفحة إرسال بلاغ
        </a>
      </form>
    </div>
  );
}